import { Mutation } from 'react-apollo';
import React from 'react';
import gql from 'graphql-tag';

import CUSTOMER_FIELDS from 'graphql/fragments/customerFields.graphql';
import EMPLOYEE_FIELDS from 'graphql/fragments/employeeFields.graphql';
import MILESTONE_FIELDS from 'graphql/fragments/milestoneFields.graphql';
import PROJECT_FIELDS from 'graphql/fragments/projectFields.graphql';
import QUICKLINK_FIELDS from 'graphql/fragments/quicklinkFields.graphql';
import STATUS_UPDATE_FIELDS from 'graphql/fragments/statusUpdateFields.graphql';
import USER_FIELDS from 'graphql/fragments/userFields.graphql';

const buildMutation = (mutation, refetchQueries) => (
  ({ children }) => (
    <Mutation mutation={mutation}>
      {(performMutation, { loading, called }) => {
        const submit = (values, onSuccess, onError) => {
          performMutation({
            variables: values,
            refetchQueries: refetchQueries
          }).then(onSuccess, onError);
        };

        return children(submit, { loading: loading, complete: called && !loading });
      }}
    </Mutation>
  )
);

const Mutations = {};

Mutations.CreateEmployee = buildMutation(
  gql`
    mutation CreateEmployee($employee: EmployeeInput!) {
      createEmployee(employee: $employee) {
        ...employeeFields
      }
    }

    ${EMPLOYEE_FIELDS}
  `,
);

Mutations.DeleteEmployee = buildMutation(
  gql`
    mutation DeleteEmployee($id: ID!) {
      deleteEmployee(employeeId: $id)
    }
  `,
  ['Employees']
);

Mutations.EditEmployee = buildMutation(
  gql`
    mutation EditEmployee($id: ID!, $employee: EmployeeInput!) {
      editEmployee(employeeId: $id, employee: $employee) {
        ...employeeFields
      }
    }

    ${EMPLOYEE_FIELDS}
  `,
);

Mutations.AddCustomersToProject = buildMutation(
  gql`
    mutation AddCustomersToProject($project: ID!, $customers: [CustomerInput]!, $welcomeMessage: String) {
      addCustomers(projectId: $project, customers: $customers, welcomeMessage: $welcomeMessage) {
        id
        customers {
          ...customerFields
        }
      }
    }

    ${CUSTOMER_FIELDS}
  `,
);

Mutations.ArchiveProject = buildMutation(
  gql`
    mutation ArchiveProject($id: ID!) {
      archiveProject(projectId: $id) {
        ...projectFields
      }
    }

    ${PROJECT_FIELDS}
    ${EMPLOYEE_FIELDS}
    ${MILESTONE_FIELDS}
    ${QUICKLINK_FIELDS}
  `,
);

Mutations.CreateProject = buildMutation(
  gql`
    mutation CreateProject($project: ProjectInput!) {
      createProject(project: $project) {
        ...projectFields
      }
    }

    ${PROJECT_FIELDS}
    ${EMPLOYEE_FIELDS}
    ${MILESTONE_FIELDS}
    ${QUICKLINK_FIELDS}
  `,
);

Mutations.CreateStatusUpdate = buildMutation(
  gql`
    mutation CreateStatusUpdate($projectId: ID!, $statusUpdate: StatusUpdateInput!) {
      createStatusUpdate(projectId: $projectId, statusUpdate: $statusUpdate) {
        ...statusUpdateFields
      }
    }

    ${STATUS_UPDATE_FIELDS}
    ${EMPLOYEE_FIELDS}
  `,
  ['ProjectUpdates']
);

Mutations.DeleteStatusUpdate = buildMutation(
  gql`
    mutation DeleteStatusUpdate($projectId: ID!, $updateId: ID!) {
      deleteStatusUpdate(projectId: $projectId, updateId: $updateId)
    }
  `,
  ['ProjectUpdates']
);

Mutations.EditProject = buildMutation(
  gql`
    mutation EditProject($id: ID!, $project: ProjectInput!) {
      editProject(projectId: $id, project: $project) {
        ...projectFields
      }
    }

    ${PROJECT_FIELDS}
    ${EMPLOYEE_FIELDS}
    ${MILESTONE_FIELDS}
    ${QUICKLINK_FIELDS}
  `,
);

Mutations.EditStatusUpdate = buildMutation(
  gql`
    mutation EditStatusUpdate($projectId: ID!, $updateId: ID!, $statusUpdate: StatusUpdateInput!) {
      editStatusUpdate(projectId: $projectId, updateId: $updateId, statusUpdate: $statusUpdate) {
        ...statusUpdateFields
      }
    }

    ${STATUS_UPDATE_FIELDS}
    ${EMPLOYEE_FIELDS}
  `,
  ['ProjectUpdates']
);


Mutations.RedeemMagicLink = buildMutation(
  gql`
    mutation RedeemMagicLink($token: String!) {
      redeemMagicLink(token: $token) {
        jwt
        user {
          ...userFields
        }
      }
    }

    ${USER_FIELDS}
  `,
);

Mutations.RemoveCustomersFromProject = buildMutation(
  gql`
    mutation RemoveCustomersFromProject($project: ID!, $customer: [ID]!) {
      removeCustomers(projectId: $project, customerIds: $customer) {
        id
        customers {
          ...customerFields
        }
      }
    }

    ${CUSTOMER_FIELDS}
  `,
);

Mutations.SendMagicLink = buildMutation(
  gql`
    mutation SendMagicLink($email: String!) {
      createMagicLink(email: $email)
    }
  `,
);

Mutations.UnarchiveProject = buildMutation(
  gql`
    mutation UnarchiveProject($id: ID!) {
      unarchiveProject(projectId: $id) {
        ...projectFields
      }
    }

    ${PROJECT_FIELDS}
    ${EMPLOYEE_FIELDS}
    ${MILESTONE_FIELDS}
    ${QUICKLINK_FIELDS}
  `,
);

export default Mutations;



// WEBPACK FOOTER //
// ./src/graphql/Mutations.js